import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { Flex, Box } from '../ui/Layout'
import ShoppableProduct from './ShoppableProduct'
import { baseUrl, formatCurrency } from '../helpers'

const ProductPill = styled(Flex)`
  box-sizing: border-box !important;
  padding: 4px !important;
  align-items: center !important;
  background-color: rgba(245, 245, 245, 0.7) !important;
  backdrop-filter: blur(10px);
  height: ${(props) => (props.noProduct ? '60' : '88')}px !important;
  padding-left: ${(props) => (!props.noProduct ? '12' : '0')}px !important;
  border-radius: 16px !important;
  color: rgba(16, 18, 37, 1) !important;
  font-family: 'Inter';
  font-size: 16px !important;
  text-align: left !important;
  cursor: pointer;
  transition: background 250ms ease-in-out 0s, transform 150ms ease 0s;
  width: calc(100% - 20px) !important;
  max-width: 400px !important;
  z-index: 1;
  position: absolute;
  bottom: ${(props) => (props.noCliparaLogo ? '12px' : '28px')};
  left: 0px;
  z-index: 110001;
  overflow: hidden;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  outline: inherit;
  p {
    text-decoration: none;
    white-space: nowrap;
    margin-bottom: 0px;
    margin-top: 0px;
    font-weight: 600;
    line-height: 24px;
    padding: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
`

const Image = styled.div`
  display: block !important;
  margin-right: 16px !important;
  width: 70px !important;
  min-width: 70px !important;
  height: 70px !important;
  border-radius: 4px !important;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
`

const Chevron = styled.img`
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  margin-right: 16px !important;
`

const OldPrice = styled.span`
  color: #425466;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-decoration: line-through !important;
`

const PillTitle = styled.p`
  white-space: normal !important;
  font-size: 16px !important;
  line-height: 18px !important;
  color: #27272e !important;
  font-weight: 600 !important;
`

const PillPrice = styled.p`
  margin-top: 8px !important;
  font-size: 16px !important;
  line-height: 18px !important;
  color: #27272e !important;
  font-weight: 400 !important;
`

const ItemTitle = styled.p`
  font-size: 14px !important;
  line-height: 18px !important;
  margin-bottom: 8px !important;
  color: #27272e !important;
  font-weight: 600 !important;
`

const ItemPrice = styled.p`
  font-size: 14px !important;
  line-height: 18px !important;
  color: #27272e !important;
  font-weight: 400 !important;
`

const ShoppableMobileButtons = ({ videoProducts, campaign, setShowProductSelect, setFullScreenProduct, playerId, currency }) => {
  if (!videoProducts || !videoProducts.length) {
    return null
  }
  if (videoProducts.length === 1) {
    const price = formatCurrency({ currency, price: videoProducts[0].product.price / 100, campaign })
    const compareAtPrice =
      videoProducts[0].product.compareAtPrice && videoProducts[0].product.compareAtPrice > 0 && !campaign.widgetHideCompareAtPrice
        ? formatCurrency({ currency, price: videoProducts[0].product.compareAtPrice / 100, campaign })
        : ''
    const image = videoProducts[0].product.media ? videoProducts[0].product.media[0].previewImage.src : ''

    return (
      <ProductPill
        noCliparaLogo={campaign.noCliparaLogo}
        onClick={() => {
          document.getElementById(playerId).pause()
          setFullScreenProduct(videoProducts[0])
        }}
      >
        <Image src={image} alt={videoProducts[0].product.title} />
        <Flex flexDirection="column">
          <PillTitle>{videoProducts[0].product.title}</PillTitle>
          <PillPrice>
            {price} {compareAtPrice && <OldPrice>{compareAtPrice}</OldPrice>}
          </PillPrice>
        </Flex>
        <Chevron src={`${baseUrl}/__clipara-chevron-left-black.svg`} alt="chevron icon" width="20px" height="20px" />
      </ProductPill>
    )
  }
  return (
    <ProductPill
      noCliparaLogo={campaign.noCliparaLogo}
      onClick={() => {
        document.getElementById(playerId).pause()
        setShowProductSelect(true)
      }}
      noProduct
    >
      <Flex ml="16px">
        <PillTitle>View Products</PillTitle>
      </Flex>
      <Chevron src={`${baseUrl}/__clipara-chevron-left-black.svg`} alt="chevron icon" width="20px" height="20px" />
    </ProductPill>
  )
}

const Container = styled(Flex)`
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: white;
  z-index: 2147483647;
  flex-direction: column;
  transform: ${(props) => (props.show ? 'translate(0%, 0%);' : 'translate(0%, 100%);')};
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  border-radius: 16px 16px 0px 0px;
`

const InnerContainer = styled(Flex)`
  box-sizing: border-box;
  flex-direction: column;
  padding-top: 2px;
  padding-bottom: 44px;
  padding-left: 16px;
  padding-right: 16px;
  p {
    text-decoration: none;
    margin-bottom: 0px;
    margin-top: 0px;
    font-weight: 600;
    line-height: 24px;
    padding: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    color: rgba(16, 18, 37, 1) !important;
    font-family: 'Inter';
    text-align: left !important;
  }
`

const Grid = styled(Flex)`
  width: 100%;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
`

const GridWrapper = styled(Flex)`
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 400px;
  &&::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

const ProductImage = styled.div`
  display: block !important;
  border-radius: 4px !important;
  margin-bottom: 8px !important;
  background-image: url(${(props) => props.src});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fcfcfc;
  border: 1px solid #ebf2fa;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
`

const Title = styled.p`
  margin-top: 16px !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  margin-bottom: 16px !important;
`

const CloseTargetBox = styled(Flex)`
  width: 40px;
  height: 40px;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`

const Close = styled.img`
  width: 16px;
  height: 16px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`

const ProductContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2147483646;
  flex-direction: column;
  transform: ${(props) => (props.show ? 'translate(0%, 0%);' : 'translate(0%, 100%);')};
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  border-radius: 16px 16px 0px 0px;
`

const Logo = styled.img`
  width: 160px;
  height: 40px;
  object-fit: contain;
`

const ShoppableFullScreen = ({
  activeVideo,
  fullScreenProduct,
  setFullScreenProduct,
  showProductSelect,
  setShowProductSelect,
  videoProducts,
  campaign,
  playerId,
  currency
}) => {
  if (!videoProducts || !videoProducts.length) {
    return null
  }
  return (
    <>
      <ProductContainer show={fullScreenProduct} id="__clipara-shoppable-product-container">
        <ShoppableProduct
          activeVideo={activeVideo}
          campaign={campaign}
          currency={currency}
          product={fullScreenProduct}
          close={() => {
            document.getElementById(playerId).play()
            setFullScreenProduct()
          }}
        />
      </ProductContainer>
      <Container show={showProductSelect} id="__clipara-shoppable-container">
        <InnerContainer>
          <CloseTargetBox
            onClick={() => {
              document.getElementById(playerId).play()
              setShowProductSelect(false)
            }}
          >
            <Close width="20px" height="20px" alt="close preview" src={`${baseUrl}/__clipara-cross-black.svg`} />
          </CloseTargetBox>
          {campaign.logoUrl ? (
            <Flex pt="6px" pb="10px" justifyContent="center">
              <Logo src={campaign.logoUrl} />
            </Flex>
          ) : (
            <Title>Shop</Title>
          )}
          <GridWrapper>
            <Box width="100%">
              <Grid>
                {videoProducts.map((product) => {
                  const price = formatCurrency({ currency, price: product.product.price / 100, campaign })
                  const compareAtPrice =
                    product.product.compareAtPrice && product.product.compareAtPrice > 0 && !campaign.widgetHideCompareAtPrice
                      ? formatCurrency({ currency, price: product.product.compareAtPrice / 100, campaign })
                      : ''
                  const image = product.product.media ? product.product.media[0].previewImage.src : ''
                  return (
                    <Flex
                      mb="14px"
                      key={product.id}
                      flexDirection="column"
                      onClick={() => {
                        setFullScreenProduct(product)
                        setShowProductSelect(false)
                      }}
                    >
                      <ProductImage src={image} alt={product.product.title} />
                      <ItemTitle>{product.product.title}</ItemTitle>
                      <ItemPrice>
                        {price} {compareAtPrice && <OldPrice>{compareAtPrice}</OldPrice>}
                      </ItemPrice>
                    </Flex>
                  )
                })}
              </Grid>
            </Box>
          </GridWrapper>
        </InnerContainer>
      </Container>
    </>
  )
}

const ShoppableMobile = ({
  videoProducts,
  campaign,
  playerId,
  activeVideo,
  currency,
  fullScreenProduct,
  setFullScreenProduct,
  showProductSelect,
  setShowProductSelect
}) => {
  // const [showProductSelect, setShowProductSelect] = useState(false)
  // const [fullScreenProduct, setFullScreenProduct] = useState()
  return (
    <>
      <ShoppableMobileButtons
        setFullScreenProduct={setFullScreenProduct}
        setShowProductSelect={setShowProductSelect}
        videoProducts={videoProducts}
        campaign={campaign}
        playerId={playerId}
        currency={currency}
      />
      <ShoppableFullScreen
        activeVideo={activeVideo}
        fullScreenProduct={fullScreenProduct}
        setFullScreenProduct={setFullScreenProduct}
        showProductSelect={showProductSelect}
        setShowProductSelect={setShowProductSelect}
        videoProducts={videoProducts}
        campaign={campaign}
        playerId={playerId}
        currency={currency}
      />
    </>
  )
}

export default ShoppableMobile
